import clsx from 'clsx';

import { Text } from '@northladder/i18n';
import { TTextLocalized, TUIError } from '@northladder/utilities';

import { translations } from '../../../translations';

import {
  PopoverMultiSelect,
  IPopoverMultiSelectProps,
} from '../popover-multi-select';

// import './tradein-devices-dropdown.css';

type ITradeInDevicesDropdownProps = Pick<
  IPopoverMultiSelectProps,
  'items' | 'error' | 'onPopoverItemSelect' | 'isModelsLoading' | 'id'
> & {
  isCategoriesLoading: boolean;
  label: TTextLocalized;
  subLabel: TTextLocalized;
  uiError?: TUIError;
};

/**
 * -----------------------------------------------------------------------------
 * This `TradeInDevicesDropdown` repurposes the PopoverMultiSelect dropdown.
 * @deprecated - Adding a deprecation notice on this since the css import might be broken
 */
export function TradeInDevicesDropdown({
  id,
  items,
  error,
  onPopoverItemSelect,
  isCategoriesLoading,
  label,
  subLabel,
  uiError,
}: ITradeInDevicesDropdownProps) {
  const errorClass = uiError ? 'has-error' : '';

  return (
    <div className={clsx('trade-in-device-dropdown-wrapper', errorClass)}>
      <div className="label-class">
        <label htmlFor={id || 'popover-multi-select'}>
          <Text text={label} />
        </label>
        <p className="sub-label-class">
          <Text text={subLabel} />
        </p>
      </div>

      <PopoverMultiSelect
        disabled={false}
        error={error}
        errorClassName={errorClass}
        id={id}
        isModelsLoading={isCategoriesLoading}
        items={items || []}
        onPopoverItemSelect={onPopoverItemSelect}
        placeholder={translations.tradeInDeviceDropdown.title}
        title={translations.tradeInDeviceDropdown.subtitle}
      />
      <div className="mt-2">
        {uiError ? <Text text={uiError.message} /> : null}
      </div>
    </div>
  );
}
